/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ca426d13653c8ea886af16effc9c1fd8b157c89c";
